"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sprout_data_1 = require("sprout-data");

var TrackingProxy =
/** @class */
function () {
  function TrackingProxy() {
    var _this = this;

    this.utils = {};
    this.proxy = true;
    this.addUtil = this.getProxiedMethod('addUtil');
    this.updateLocation = this.getProxiedMethod('updateLocation');
    this.event = this.getProxiedMethod('event');
    this.addPixel = this.getProxiedMethod('addPixel');
    this.use = this.getProxiedMethod('use');
    this._stateAcc = {};
    this._listeners = Object.create(null);
    this.ready = new Promise(function (resolve) {
      _this._readyResolve = resolve;
    });
    this.trackingReady = new Promise(function (resolve) {
      _this._trackingResolve = resolve;
    });
  }

  Object.defineProperty(TrackingProxy.prototype, "_version", {
    get: function () {
      if (this.tracking) {
        return this.tracking._version;
      }

      return 'proxy-' + "4.67.0";
    },
    enumerable: false,
    configurable: true
  });

  TrackingProxy.prototype.setTracking = function (tracking) {
    var _this = this;

    this.tracking = tracking;
    var stateHasSomething = Object.keys(tracking.state).length > 0;

    this._trackingResolve(tracking);

    tracking.ready.then(this._readyResolve);
    tracking.extend(this._stateAcc);

    if (stateHasSomething && this._listeners.change) {
      this._listeners.change.forEach(function (cb) {
        cb(tracking.state, _this._stateAcc);
      });
    } // cleanup


    this._listeners = Object.create(null);
  };

  TrackingProxy.prototype.addPixels = function (urls) {
    if (this.tracking) {
      return this.tracking.addPixels(urls);
    }

    return this.trackingReady.then(function (tracking) {
      return tracking.addPixels(urls);
    });
  };

  TrackingProxy.prototype.resolve = function (willBeTracking) {
    var _this = this;

    return Promise.resolve(willBeTracking).then(function (tracking) {
      _this.setTracking(tracking);

      return tracking;
    });
  };

  Object.defineProperty(TrackingProxy.prototype, "state", {
    get: function () {
      if (this.tracking) {
        return this.tracking.state;
      } else {
        return this._stateAcc;
      }
    },
    enumerable: false,
    configurable: true
  });

  TrackingProxy.prototype.callUtil = function (name) {
    var _a;

    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    if (this.tracking) {
      return (_a = this.tracking).callUtil.apply(_a, __spreadArrays([name], args));
    }

    return this.trackingReady.then(function (tracking) {
      return tracking.callUtil.apply(tracking, __spreadArrays([name], args));
    });
  };

  TrackingProxy.prototype.fullfill = function (dataProviders) {
    if (this.tracking) {
      return this.tracking.fullfill(dataProviders);
    }

    return this.trackingReady.then(function (tracking) {
      return tracking.fullfill(dataProviders);
    });
  };

  TrackingProxy.prototype.extend = function (payload) {
    if (this.tracking) {
      return this.tracking.extend(payload);
    } else {
      var newState = Object.keys(payload).reduce(function (acc, key) {
        var keyPath = key.split('.');
        return sprout_data_1.assoc(acc, keyPath, payload[key]);
      }, this._stateAcc);
      return this.update(newState);
    }
  };

  TrackingProxy.prototype.update = function (newState) {
    if (this.tracking) {
      return this.tracking.update(newState);
    }

    var prevState = this._stateAcc;

    if (prevState !== newState) {
      this._stateAcc = newState;
    }

    return this;
  };

  TrackingProxy.prototype.remove = function () {
    var _a;

    var keys = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      keys[_i] = arguments[_i];
    }

    if (this.tracking) {
      return (_a = this.tracking).remove.apply(_a, keys);
    }

    var newState = sprout_data_1.dissoc.apply(void 0, __spreadArrays([this._stateAcc], keys.map(function (key) {
      return key.split('.');
    })));
    return this.update(newState);
  };

  TrackingProxy.prototype.on = function (event, fn) {
    if (this.tracking) {
      this.tracking.on(event, fn);
    } else {
      if (event === 'change') {
        this._listeners[event] = this._listeners[event] || [];

        this._listeners[event].push(fn);
      }

      this.trackingReady.then(function (tracking) {
        tracking.on(event, fn);
      });
    }
  };

  TrackingProxy.prototype.off = function (event, fn) {
    if (this.tracking) {
      this.tracking.off(event, fn);
    } else {
      if (event === 'change' && this._listeners[event]) {
        this._listeners[event] = this._listeners[event].filter(function (cb) {
          return cb !== fn;
        });
      }

      this.trackingReady.then(function (tracking) {
        tracking.off(event, fn);
      });
    }
  };

  TrackingProxy.prototype.emit = function (type) {
    var _a;

    var eventArgs = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      eventArgs[_i - 1] = arguments[_i];
    }

    if (this.tracking) {
      (_a = this.tracking).emit.apply(_a, __spreadArrays([type], eventArgs));
    } else {
      this.trackingReady.then(function (tracking) {
        tracking.emit.apply(tracking, __spreadArrays([type], eventArgs));
      });
    }
  };

  TrackingProxy.prototype.waitFor = function (name) {
    return this.trackingReady.then(function (tracking) {
      return tracking.waitFor(name);
    });
  }; // возвращает обертку, которая вызовет метод только на настоящем трекинге


  TrackingProxy.prototype.getProxiedMethod = function (methodName) {
    var _this = this;

    return function () {
      var _a;

      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      if (_this.tracking) {
        (_a = _this.tracking)[methodName].apply(_a, args);
      } else {
        _this.trackingReady.then(function (tracking) {
          tracking[methodName].apply(tracking, args);
        });
      }

      return _this;
    };
  };

  return TrackingProxy;
}();

exports.default = TrackingProxy;